// extracted by mini-css-extract-plugin
export var copy = "multicol-module--copy--573c3";
export var factory = "multicol-module--factory--c227a";
export var more = "multicol-module--more--b5648";
export var more_wr = "multicol-module--more_wr--33990";
export var multicol = "multicol-module--multicol--9232c";
export var story_fixed = "multicol-module--story_fixed--a9f4b";
export var subtitle = "multicol-module--subtitle--25a07";
export var title = "multicol-module--title--21f47";